// Donor-scope calendar API helper — comp-ε GAP-3a (CHG-2403 / ITER-905145).
//
// Backend: donor_portal_calendar.py, mounted at /api/v1/my-giving/calendar/*
// (comp-ε). The agenda envelope mirrors the admin /ai/calendar/events shape so
// this v2 helper types it the same way the v1 page (web/dashboard MyCalendar)
// already consumes it.
//
//   GET  /my-giving/calendar/events?days=N   -> DonorCalendarResponse
//   GET  /my-giving/calendar/feed-url        -> DonorFeedUrlResponse
//   POST /my-giving/calendar/feed-url/regenerate -> DonorFeedUrlRegenResponse

import { apiClient } from "./client";

export interface DonorCalendarEvent {
  id: string;
  title: string;
  date: string;
  end_date?: string | null;
  type: string;
  calendar: string;
  description?: string;
  color?: string;
  days_until: number;
  auto_campaign?: boolean;
  date_precision?: string;
}

export interface DonorCalendarResponse {
  data: {
    events: DonorCalendarEvent[];
    calendars: string[];
    org_timezone: string;
    currency: string;
  };
}

export interface DonorFeedUrlResponse {
  data: {
    feed_url: string;
    instructions: {
      google: string;
      outlook: string;
      apple: string;
    };
  };
}

export interface DonorFeedUrlRegenResponse {
  data: {
    feed_url: string;
    regenerated: boolean;
  };
}

// days clamps server-side to [7, 365]; the dashboard agenda defaults to 90.
export async function fetchCalendarEvents(
  days = 90,
): Promise<DonorCalendarResponse> {
  const r = await apiClient().get<DonorCalendarResponse>(
    "/my-giving/calendar/events",
    { params: { days } },
  );
  return r.data;
}

export async function fetchFeedUrl(): Promise<DonorFeedUrlResponse> {
  const r = await apiClient().get<DonorFeedUrlResponse>(
    "/my-giving/calendar/feed-url",
  );
  return r.data;
}

export async function regenerateFeedUrl(): Promise<DonorFeedUrlRegenResponse> {
  const r = await apiClient().post<DonorFeedUrlRegenResponse>(
    "/my-giving/calendar/feed-url/regenerate",
  );
  return r.data;
}

export const meCalendarApi = {
  fetchCalendarEvents,
  fetchFeedUrl,
  regenerateFeedUrl,
};
